import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Checkbox extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override CheckboxBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Checkbox> */
    className: PropTypes.string,
    /** Checkbox checked/unchecked */
    checked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    /** Text used for input label */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    required: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: this.isChecked(),
    };
  }

  isChecked = () => {
    let checkboxValue = false;

    if (this.props.value) {
      checkboxValue = this.convertValue(this.props.value);
    }

    if (typeof this.props.checked !== 'undefined') {
      checkboxValue = this.convertValue(this.props.checked);
    }

    return checkboxValue;
  };

  convertValue = value => {
    let checked = false;
    if (value !== null && value !== undefined) checked = typeof value === 'boolean' ? value : value.toLowerCase() === 'true' ? true : false;
    return checked;
  };

  handleChange = event => {
    if (this.props.disabled) {
      return;
    }

    this.setState(
      prevState => ({
        checked: !prevState.checked,
      }),
      () => {
        if (this.props.onChange) {
          this.props.onChange({ target: { value: this.state.checked } });
        }
      },
    );
  };

  checkBoxSVG = () => {
    const { checked } = this.state;

    if (checked) {
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-355.000000, -3298.000000)">
              <rect fill="#FFFFFF" x="0" y="0" width="1600" height="3397"></rect>
              <g className="checkbox-icon-container" transform="translate(352.000000, 3295.000000)">
                <rect className="checkbox-icon" fill="#2E2E38" x="3" y="3" width="18" height="18"></rect>
                <polygon
                  fill="#FFFFFF"
                  points="9.70765027 14.8795902 17.0215027 7.54915301 18 8.52765027 9.70765027 16.82 5.86 12.9723497 6.82191257 11.9938525"></polygon>
              </g>
            </g>
          </g>
        </svg>
      );
    } else {
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-403.000000, -3298.000000)">
              <rect fill="#FFFFFF" x="0" y="0" width="1600" height="3397"></rect>
              <g className="checkbox-icon-container" transform="translate(400.000000, 3295.000000)" stroke="#2E2E38">
                <rect className="checkbox-icon" x="3.5" y="3.5" width="17" height="17"></rect>
              </g>
            </g>
          </g>
        </svg>
      );
    }
  };

  render() {
    const { label, required, disabled } = this.props;

    const checkboxClass = classNames({
      checkbox: true,
      disabled,
    });

    return (
      <fieldset className="checkbox-container">
        <div
          role="checkbox"
          tabIndex="0"
          aria-checked={this.state.checked}
          className={checkboxClass}
          onKeyPress={this.handleChange}
          onClick={this.handleChange}>
          <div className="checkbox-check-container">{this.checkBoxSVG()}</div>
          {label && <label className="checkbox-label">{required ? `${label} *` : label}</label>}
        </div>
      </fieldset>
    );
  }
}

export default Checkbox;
